import React, { useState, useEffect, useContext } from 'react'
import { httprequesthandler } from './httprequesthandler';
// import axios from 'axios';

const AppContext = React.createContext()

var distributor_data = [];

const AppProvider = ({ children }) => {

    const [jsonData, setJsonData] = useState([]);
    const [jsonDataDummy, setJsonDataDummy] = useState([]);
    // const [distributorList, setDistributorList] = useState([]);

    // const [popUp, setPopUp] = useState([]);
    // const [data, setData] = useState();


    const datafetch = () => {
        httprequesthandler('data.json').then(function (data) {
            // console.log(data)
            var menuData;
            //   menuData = data.EN.menus.filter(val => val.menuVisibility !== 'hide')
              menuData = data;
            //   popUpData = data.EN.popupContent.filter(val => val.menuVisibility !== 'hide')
            //    console.log(popUpData)
              return menuData;
            // setJsonData(menuData);
        }).then(function (menuData) {

            // console.log('menuData productTypeList ', menuData)
            window.selectedConfig = {...menuData.onLoadActiveradioButton}
            setJsonData(menuData);

            // setJsonDataDummy(menuData);

            // setPopUp(popUpData);

        }).then(function () {
        //    console.log("the distributor content");
        });
    }

    // console.log("the data inside the jsonData is", jsonData);

    



    useEffect(() => {
        if (jsonData.length == 0) {
            datafetch();
        }
        // if (distributorList.length == 0) {
        //     distributor(); // distributor code commented
        // }
    }, [])
    // useEffect(() => {
    //     // distributorUpdated();
    //     // console.log('useEffect distributorUpdated called')
    // }, [jsonDataDummy, distributorList])

    // const [jsonData, setJsonData] = useState([]);
    // const [distributorList, setDistributorList] = useState([]);
    // console.log('jsonData AppContext', jsonData);
    return (
        <AppContext.Provider
            value={{
                jsonData
            }}>
            { jsonData.length != 0 && children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext)
}

export { AppContext, AppProvider }